export default __webpack_public_path__ + "static/media/swap_active1.5e445788.svg";